import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../../hooks/useScale';
import { useColors } from '../../../hooks/useColors';
import theme from '../../../common/theme';

const ColumnsOnScreenModalStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        background: {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.colors.modalBg,
        },
        container: {
          padding: scale(20),
          overflow: 'hidden',
          borderRadius: theme.radius.l,
          height: 'auto',
          width: scale(380),
          backgroundColor: colors.elevation0,
        },
        title: {
          color: colors.accent,
          fontSize: scale(16),
          lineHeight: scale(22),
          fontFamily: theme.fonts.medium,
          textAlign: 'left',
          marginBottom: scale(16),
        },
        sectionLabel: {
          color: colors.text,
          fontSize: scale(14),
          lineHeight: scale(18),
          fontFamily: theme.fonts.medium,
          marginTop: scale(16),
          marginBottom: scale(8),
        },
        gridContainer: {
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          marginBottom: scale(4),
        },
        gridOption: {
          width: scale(70),
          height: scale(40),
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: theme.radius.s,
          marginHorizontal: scale(2),
          marginBottom: scale(4),
        },
        gridOptionText: {
          fontSize: scale(14),
          lineHeight: scale(18),
          fontFamily: theme.fonts.medium,
        },
        noteText: {
          fontSize: scale(12),
          lineHeight: scale(16),
          color: colors.text,
          marginTop: scale(8),
          marginBottom: scale(8),
        },
        confirmBtn: {
          width: '100%',
          height: scale(44),
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: theme.radius.s,
          marginTop: scale(20),
        },
        confirmBtnText: {
          fontSize: scale(14),
          lineHeight: scale(20),
          fontFamily: theme.fonts.medium,
        },
        dismissBtn: {
          width: '100%',
          height: scale(44),
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: colors.background,
          marginTop: scale(8),
        },
        dismissBtnText: {
          fontSize: scale(14),
          lineHeight: scale(20),
          fontFamily: theme.fonts.regular,
        },
      }),
    [colors, scale],
  );
};

export default ColumnsOnScreenModalStyles;
